import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'app-dialog-idle-time',
    templateUrl: './dialog-idle-time.component.html',
    styles: [],
    standalone: false
})
export class DialogIdleTimeComponent implements OnInit {

  constructor(private dialog:MatDialog) { }

  ngOnInit(): void {
  }

  closeDialog(){
    this.dialog.closeAll();
  }

}
